// import React from 'react'
// import Container from 'react-bootstrap/Container';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Useletter from '../Useletter';
// import Foter from '../Foter';
// import { useState } from 'react';
// import axios from 'axios';
// function Track() {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);


//   const handleLogin = async () => {
//     // Validation checks
//     if (!name.trim()) {
//       alert('Please enter your name.');
//       return;
//     }
//     if (!email.trim()) {
//       alert('Please enter your email.');
//       return;
//     }
//     if (!password.trim()) {
//       alert('Please enter your password.');
//       return;
//     }
  
//     try {
//       const response = await axios.post('http://localhost:4000/user/register', {
//         name,
//         email,
//         password,
//       });
  
//       // Success
//       console.log('Login Success:', response.data);
//       alert('Login Success');
//       // Redirect or save token
//     } catch (error) {
//       console.error('Login Failed:', error.response?.data || error.message);
//       alert('Login Failed. Please try again.');
//     }
//   };
//   return (


//     <div>
//         <Container>
//           <br />
//       <Row>
//         <Col style={{textAlign:"left",fontFamily:"Alata,sans serif", marginLeft: "0"}} ><h5>CUSTOMER LOGIN </h5>
//         <br />
//          <p style={{fontSize:"12px",fontFamily:"Alata,sans serif"}}>REGISTERED CUSTOMERS</p>
//  <b><hr /></b>    
//  <p style={{fontSize:"12px",fontFamily:"Alata,sans serif"}}>If you have an account, sign in with your email address.</p>    

//  <br />
 
 
//  <label class="label" for="email"><span>Name</span></label>
// <br />
//  <input
//  required 
//   style={{ height: "45px", width: "475px" }}
//   name="name"
//   id="name"
//   type="name"
//   className="input-text"
//   title="name"
//   value={name}
//   onChange={(e) => setName(e.target.value)}
// />         
// <br />
       
//         <label class="label" for="email"><span>Email</span></label>
  
//         <div class="control">
//       <input
//   style={{ height: "45px", width: "475px" }}
//   name="email"
//   id="email"
//   type="email"
//   className="input-text"
//   title="email"
//   value={email}
//   onChange={(e) => setEmail(e.target.value)} required

// />  
//                     </div>
//                     <br /> <br />

//       <label for="pass" class="label"><span>Password</span></label>
//       <div class="control">
//   <input style={{height:"45px", width:"475px"}}    type={showPassword ? "text" : "password"} className="input-text"id="password" title="Password" value={password} onChange={(e) => setPassword(e.target.value)} ></input>
//                     </div>

// <br />
//         <div className="field"> <input  type="checkbox"  id="show-password" class="checkbox"  checked={showPassword} onChange={() => setShowPassword(!showPassword)}></input> 
//            <label style={{fontSize:"12px",fontFamily:"Alata,sans serif"}}><span >Show password</span> </label></div>
//        <br /> 
//       <div className="fill" style={{display:"flex", gap:"10px"}}>
//         <div> <button className="bt" onClick={handleLogin} type='submit'> <span>SIGN IN</span></button></div>
//           <div className="secd"><a href="/forgot" style={{textDecoration:"none",color:"inherit"}}><span style={{fontSize:"12px",fontFamily:"Alata,sans serif"}}>Forgot your Password?</span></a></div>
//         <div className="secd"></div>
//      </div>      
//       <br />
//       <div className="req"> <span style={{fontSize:"12px",fontFamily:"Alata,sans serif",color:"red"}}>Required Field</span></div>
      
      
      
//         </Col>

//         <Col style={{textAlign:"left",fontFamily:"Alata,sans serif", marginLeft: "0"}} >
//         <br />
//          <p style={{fontSize:"12px",fontFamily:"Alata,sans serif",marginTop:"33px"}}>NEW CUSTOMERS</p>
//  <b><hr /></b> 
//  <p style={{fontSize:"12px",fontFamily:"Alata,sans serif"}}>Creating an account has many benefits: check out faster, keep more than one address, track orders and more.</p>    
//  <div> <button className="bt" style={{fontSize:"12px",fontFamily:"Alata,sans serif"}}> <a href="/create" style={{textDecoration:"none",color:"inherit"}}><span>CREATE AN ACCOUNT</span></a></button></div>

 
 
 
//  </Col>

//       </Row>
//     </Container>
//     <Useletter/> 
//     <Foter/>              
//     </div>
//   )
// }

// export default Track
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';
import { useState } from 'react';
import axios from 'axios';

function Track() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // Validation error states
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handleLogin = async () => {
    let isValid = true;

    // Reset error messages
    setNameError('');
    setEmailError('');
    setPasswordError('');

    // Validation checks
    if (!name.trim()) {
      setNameError('Name is a required field.');
      isValid = false;
    }
    if (!email.trim()) {
      setEmailError('Email is a required field.');
      isValid = false;
    }
    if (!password.trim()) {
      setPasswordError('Password is a required field.');
      isValid = false;
    }

    if (!isValid) {
      return; // Stop execution if validation fails
    }

    try {
      const response = await axios.post('http://localhost:4000/user/register', {
        name,
        email,
        password,
      });

      // Success
      console.log('Login Success:', response.data);
      alert('Login Success');
    } catch (error) {
      console.error('Login Failed:', error.response?.data || error.message);
      alert('Login Failed. Please try again.');
    }
  };

  return (
    <div>
      <Container>
        <br />
        <Row>
          <Col style={{ textAlign: 'left', fontFamily: 'Alata,sans serif', marginLeft: '0' }}>
            <h5>CUSTOMER LOGIN</h5>
            <br />
            <p style={{ fontSize: '12px', fontFamily: 'Alata,sans serif' }}>REGISTERED CUSTOMERS</p>
            <b>
              <hr />
            </b>
            <p style={{ fontSize: '12px', fontFamily: 'Alata,sans serif' }}>
              If you have an account, sign in with your email address.
            </p>
            <br />

            <label className="label" htmlFor="name">
              <span>Name</span>
            </label>
            <br />
            <input
              required
              style={{ height: '45px', width: '475px' }}
              name="name"
              id="name"
              type="name"
              className="input-text"
              title="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {nameError && <p style={{ color: 'red', fontSize: '12px' }}>{nameError}</p>}
            <br />

            <label className="label" htmlFor="email">
              <span>Email</span>
            </label>
            <div className="control">
              <input
                style={{ height: '45px', width: '475px' }}
                name="email"
                id="email"
                type="email"
                className="input-text"
                title="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {emailError && <p style={{ color: 'red', fontSize: '12px' }}>{emailError}</p>}
            </div>
            <br /> <br />

            <label htmlFor="pass" className="label">
              <span>Password</span>
            </label>
            <div className="control">
              <input
                style={{ height: '45px', width: '475px' }}
                type={showPassword ? 'text' : 'password'}
                className="input-text"
                id="password"
                title="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></input>
              {passwordError && <p style={{ color: 'red', fontSize: '12px' }}>{passwordError}</p>}
            </div>

            <br />
            <div className="field">
              <input
                type="checkbox"
                id="show-password"
                className="checkbox"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
              ></input>
              <label style={{ fontSize: '12px', fontFamily: 'Alata,sans serif' }}>
                <span>Show password</span>
              </label>
            </div>
            <br />
            <div className="fill" style={{ display: 'flex', gap: '10px' }}>
              <div>
                <button className="bt" onClick={handleLogin} type="submit">
                  <span>SIGN IN</span>
                </button>
              </div>
              <div className="secd">
                <a href="/forgot" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <span style={{ fontSize: '12px', fontFamily: 'Alata,sans serif' }}>Forgot your Password?</span>
                </a>
              </div>
              <div className="secd"></div>
            </div>
            <br />
            <div className="req">
              <span style={{ fontSize: '12px', fontFamily: 'Alata,sans serif', color: 'red' }}>Required Field</span>
            </div>
          </Col>

          <Col style={{ textAlign: 'left', fontFamily: 'Alata,sans serif', marginLeft: '0' }}>
            <br />
            <p style={{ fontSize: '12px', fontFamily: 'Alata,sans serif', marginTop: '33px' }}>NEW CUSTOMERS</p>
            <b>
              <hr />
            </b>
            <p style={{ fontSize: '12px', fontFamily: 'Alata,sans serif' }}>
              Creating an account has many benefits: check out faster, keep more than one address, track orders and more.
            </p>
            <div>
              <button className="bt" style={{ fontSize: '12px', fontFamily: 'Alata,sans serif' }}>
                <a href="/create" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <span>CREATE AN ACCOUNT</span>
                </a>
              </button>
            </div>
          </Col>
        </Row>
      </Container>
      <Useletter />
      <Foter />
    </div>
  );
}

export default Track;